










































import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { goToUrl, matchedIndexIdInArray, TypeParams } from '../../core/utils';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { NormsServices } from '../api/NormsServices';
import { PageTitle } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import { formatList } from '../../core/utils';
import { VariableReport, VariableReportList } from '../models/VariableReport';
import { ParameterList } from '../models/Parameter';

@Component({
    components: {
        PageTitle,
        SimpleTable,
        Button,
        Input
    }
})
export default class NormasParameterList extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper
) {
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [true];
    pendingRequest: boolean = false;
    search: string = '';
    pageTitle: string = 'Listado de parámetros de frames';

    headers: Array<object> = [
        {
            text: 'ID',
            align: 'center',
            value: 'id',
            width: '80px'
        },
        {
            text: 'Parámetro',
            align: 'left',
            value: 'variable_definition.description',
        },
        {
            text: 'Frame',
            align: 'left',
            value: 'frame.description',
        },
        {
            text: 'Slot',
            align: 'center',
            value: 'slot.description',
        },
        {
            text: 'Unidad',
            align: 'center',
            value: 'unit.description',
        },
        {
            text: 'Variable classification',
            align: 'left',
            value: 'variable_classification.description',
        },
        {
            text: 'Acciones',
            align: 'left',
            value: 'actions',
            sortable: false,
            width: '80px'
        }
    ];
    itemsTable: Array<ParameterList> = [];
    visibleModalVariableReport: boolean = false;

    seeParameter(item) {
        let frameId = item['frame']['id'];
        let paramterID = item['id'];

        this.$router.push(
            { 
                name: NAME_ROUTES.NORMAS_LIST_FRAMES.name, 
                    params: {
                        id: frameId,
                        pid: paramterID
                    }
            }
        );
    }


    updateSearchValue(value) {
        this.search = value;
    }
    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    mounted() {
        this.$nextTick(() => {
            this.getVariables();
        })
    }

    loadingTable(value) {
        this.pendingRequest = value;
    }

    getVariables() {
        this.loadingTable(true);

        NormsServices.getParametersVariableGeneral()
            .then((res: Array<ParameterList>) => {
                this.itemsTable = res['parameter_list'];
                this.loadingTable(false);
            })
            .catch(res => {
                this.loadingTable(false);
                
            });
    }

    formatClassifications(value) {
        return formatList(value, 'description');
    }
}
